import React, { createContext, useContext, useState } from "react";
import ErrorModal from '../components/elements/ErrorModal';

const ErrorContext = createContext();

export const useError = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [onAction, setOnAction] = useState(null);

  const showError = (message, action = null) => {
    // Only set error if message is not empty or whitespace
    if (message && message.toString().trim() !== "") {
      setError(message);
      setOnAction(() => action);
    }
  };

  const clearError = () => {
    setError(null);
    setOnAction(null);
  };

  return (
    <ErrorContext.Provider value={{ error, showError, clearError }}>
      {children}
      <ErrorModal
        isOpen={!!error}
        message={error}
        onClose={clearError}
        onAction={onAction}
      />
    </ErrorContext.Provider>
  );
};
